document.addEventListener('DOMContentLoaded', function() {
    let buttonVisibleBlock = document.querySelector('.button-visible-block');
    let buttonHiddenBlock = document.querySelector('.button-hidden-block');
    let buttonVisible = document.querySelector('.button-visible');
    let buttonHidden = document.querySelector('.button-hidden');

    buttonVisibleBlock?.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.visible-text-block').style.display = 'none';
        if (document.body.classList.contains('animateOff')) {
            document.querySelector('.hidden-text-block').style.display = 'block';
        } else {
            document.querySelector('.hidden-text-block').style.display = 'block'; // SlideDown effect needs to be implemented separately if required
        }
        this.style.display = 'none';
        buttonHiddenBlock.style.display = 'block';
    });

    buttonHiddenBlock?.addEventListener('click', function(e) {
        e.preventDefault();
        if (document.body.classList.contains('animateOff')) {
            document.querySelector('.visible-text-block').style.display = 'block';
        } else {
            document.querySelector('.visible-text-block').style.display = 'block'; // FadeIn effect needs to be implemented separately if required
        }
        document.querySelector('.hidden-text-block').style.display = 'none';
        this.style.display = 'none';
        buttonVisibleBlock.style.display = 'block';
    });

    buttonVisible?.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.visible-text').style.display = 'none';
        if (document.body.classList.contains('animateOff')) {
            document.querySelector('.hidden-text').style.display = 'block';
        } else {
            document.querySelector('.hidden-text').style.display = 'block'; // SlideDown effect needs to be implemented separately if required
        }
        buttonVisible.style.display = 'none';
        buttonHidden.style.display = 'block';
    });

    buttonHidden?.addEventListener('click', function(e) {
        e.preventDefault();
        if (document.body.classList.contains('animateOff')) {
            document.querySelector('.visible-text').style.display = 'block';
        } else {
            document.querySelector('.visible-text').style.display = 'block'; // FadeIn effect needs to be implemented separately if required
        }
        document.querySelector('.hidden-text').style.display = 'none';
        buttonHidden.style.display = 'none';
        buttonVisible.style.display = 'block';
    });
});